export const defaultRejectReason = [
    {
        "id": "aefyuh",
        "text": "Invalid Document"
    },
    {
        "id": "dfgsdh",
        "text": "The Image is blurry"
    },
    {
        "id": "tyhgfd",
        "text": "The Document has expire"
    },
    {
        "id": "ghjklo",
        "text": "Name on Id different from on profile"
    },
    {
        "id": "fghjas",
        "text": "Address in document different from Address on profile"
    },
]